import React, {useState} from 'react';
import {Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography} from '@mui/material';

export default function MicrochipOrderDialog({ open, onClose, onConfirm, defaultEmail, defaultTemplate, clinic, quantity }) {
    const [email, setEmail] = useState(defaultEmail || '');
    const [template, setTemplate] = useState(defaultTemplate || '');
    const [editing, setEditing] = useState(false);

    React.useEffect(() => {
        setEmail(defaultEmail || '');
        setTemplate(defaultTemplate || '');
    }, [defaultEmail, defaultTemplate, open]);

    const filledTemplate = template
        .replace('[amount]', quantity)
        .replace('[vet clinic name]', clinic?.clinicName || '')
        .replace('[address]', clinic?.address || '')
        .replace('[contact name]', clinic?.contactName || '')
        .replace('[vet number]', clinic?.vetNumber || '');

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Order Microchips</DialogTitle>
            <DialogContent>
                <Typography variant="body2" gutterBottom>
                    Please confirm the order details and recipient email. You can edit the email or wording if needed.
                </Typography>
                <TextField
                    label="Supplier Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Email Content"
                    value={editing ? template : filledTemplate}
                    onChange={e => { setTemplate(e.target.value); setEditing(true); }}
                    fullWidth
                    multiline
                    minRows={7}
                    margin="normal"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant="contained" onClick={() => onConfirm({ email, content: editing ? template : filledTemplate })}>
                    Confirm &amp; Send
                </Button>
            </DialogActions>
        </Dialog>
    );
}
